import { de, enUS } from 'date-fns/locale';

const STORAGE_KEY = 'i18nextLng';

export const getDateFnsLocale = () => {
  const savedLang = localStorage.getItem(STORAGE_KEY) || 'de';

  if (savedLang.startsWith('en')) {
    return enUS;
  }

  return de;
};
